import axios from 'axios';
import { setGlobalLoader } from '../../context/LoaderContext';
import { api, url } from '../api'
import { Alert } from '../../util/Alert';
import { toast } from 'react-toastify';
import { deleteCookie, getCookie } from '../../util/Cookie';

export const GetLoans = (userId, callBack) => {
    axios.get(url + '/api/Emprestimo/cliente/' + userId, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {
            if (err.response?.status === 401) {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
            Alert(err.response?.data.message, "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });
}

export const SendToken = (token, solicitaionNumber, callBack) => {
    var req = { "numeroSolicitacao": solicitaionNumber, "Token": token }
    axios.post(url + '/api/Emprestimo/in100/validar-token', req, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {
            if (err.response?.status === 401) {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
            Alert(err.response?.data.message, "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });
}

export const ReSendToken = () => {
    axios.post(url + '/api/Emprestimo/in100/reenviar-sms', {}, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            Alert(result.data.mensagem);
        })
        .catch((err) => {
            if (err.response?.status === 401) {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
            Alert(err.response?.data.message, "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });
}

export const SimulateLoan = (nb, product, solicitationValue, installments, income, callBack, setIsRequiredToken, isResend) => {
    var req = {
        "valorLiberado": solicitationValue,
        "valorRenda": income,
        "codigoProduto": Number(product),
        "codigoBeneficio": String(nb),
    }

    setGlobalLoader(true);
    axios.post(url + '/api/Emprestimo/simular', req, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            setIsRequiredToken(false);
            callBack(result.data);
        })
        .catch((err) => {

            console.error(err);
            if (err.response?.status === 401 && err.response?.data?.message !== "Login ou senha inválidos") {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
            if (err.response?.status === 428) {
                setIsRequiredToken(true, err.response.data.numeroSolicitacao);
                if (isResend)
                    Alert("Token reenviado com sucesso!", "", false, false, true);
                else
                    Alert(err.response.data.mensagem, "", false, false, true);
                return;
            }
            Alert("Houve um erro na solicitação", "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });

}

export const SendLoanProposal = (req, callBack) => {
    setGlobalLoader(true);
    axios.post(url + '/api/emprestimo/gravar-proposta', req, {
        headers: {
            "Authorization": `Bearer ${getCookie("access_token")}`
        }
    })
        .then((result) => {
            callBack(result.data);
        })
        .catch((err) => {
            console.error(err);
            if (err.response?.status === 401 && err.response?.data?.message !== "Login ou senha inválidos") {
                toast.error("Sessão expirada");
                deleteCookie("access_token");
                deleteCookie("user_data");
                window.location.href = api.loginPage;
                return;
            }
            Alert("Houve um erro na solicitação", "", false);
        })
        .finally(() => {
            setGlobalLoader(false);
        });

}